import React from 'react';
import ReactDOM from 'react-dom/client';
import "materialize-css/dist/css/materialize.min.css"
import "materialize-css/dist/js/materialize.min.js"
import './index.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

    /*"pdfjs-dist": "^2.15.349",*/
        /*"@react-pdf-viewer/core": "^3.7.0",*/
    /*"@react-pdf-viewer/default-layout": "^3.7.0",*/
    /*"@react-pdf-viewer/get-file": "^3.7.0",*/

